(function($, root) {

  $('html').on('click touchstart', '.show-index header .menu-icon', function() {
    if (window.rdo.index.shown) {
      $.showTimelinePlayer(function() {

        console.log('CLOSE INDEX + CALLBACK RUN');

        window.rdo.preloading = 'this';
        if (window.rdo.data.selected.content.subject) {
          $.selectSubject(window.rdo.data.selected.subject.index);
        } else {
          $.selectContent(window.rdo.data.selected.content.index);
        }
      });
    }
  });

  $('html').on('click touchstart', '.show-content header .menu-icon', function() {
    if (!window.rdo.index.shown) {
      // console.log('load index');
      $.showIndex();
    }
  });

  $.showTimelinePlayer = function(callbacks) {
    console.log('SHOWING TIMELINE PLAYER');
    // $.renderTimelinePlayer();

    $('main .main').removeClass('fadeOut').addClass('fadeIn');

    $('index .index').removeClass('fadeIn').animateCss('fadeOut', function() {
      window.rdo.header.shown = false;

      $('body').removeClass('show-index').addClass('show-content');
      $('index').html('');
      $('index').removeClass('active');

      setTimeout(function() {
        console.log('CLOSE INDEX + TIMEOUT 500 DONE');
        $('main').fadeIn();
        $('index').fadeOut();
        $('#vertical-timeline').getInitialScrollPositions('.sitem', '#vertical-timeline .wrapper');
      callbacks();
      }, 500);

      setTimeout(function() {
        console.log('CLOSE INDEX + TIMEOUT 1500 DONE');
        window.rdo.index.shown = false;
      }, 1500);

      // setTimeout(function() {
      //   $('body').removeClass('dark-bg');
      // }, 2000);



    });

  };

  $.showIndex = function() {
    $.pauseTimer(true);
    $.renderIndex();
    // $.hideSpinner();
    $('body').addClass('dark-bg');
    $('index .index').removeClass('fadeOut')
      // .addClass('fadeIn');

      .animateCss('fadeIn', function() {
        // $('body').addClass('dark-bg');
        // $('main').fadeOut();
        $('main').html('');

      });

    // .addClass('fadeIn');

    $.hideMain("index");

  };

  //index mode:
  $('html').on('click touchstart', '.show-index .year .subject-explainer', function() {
    let clicked = $(this);

    $.showTimelinePlayer(function() {
      window.rdo.preloading = 'this';
      console.log('CLICKED SUBJECT IN INDEX + CALLBACK RUN');
      //when a year is clicked on vertical timeline:
      let year = clicked.attr('data-year');
      let subject = clicked.attr('data-subject');

      console.log('lets go to: ' + year + ' su:' + subject);
      $.selectYear(year, subject);

      // $.resetTimer();
    });

  });

  //content clicked in index:
  $('html').on('click touchstart', '.show-index .year .contents .content', function() {
    let clicked = $(this);
    $.showTimelinePlayer(function() {

      console.log('CLICKED CONTENT IN INDEX + CALLBACK RUN');

      window.rdo.preloading = 'this';

      //when a year is clicked on vertical timeline:
      let year = clicked.attr('data-year');
      let subject = clicked.attr('data-subject');
      let content = clicked.attr('data-content');

      console.log('lets go to: ' + year + ' su:' + subject + ' co:' + content);
      $.selectYear(year, subject, content);

      // $.resetTimer();

    });

  });

})(jQuery, this);
